export const generateCommunityList = (communities: any) => {
  return Object.keys(communities).map( (c: string) => {
      return {
        description: c,
        key: 'community',
        value: c,
      }
    })
  }



// WEBPACK FOOTER //
// ./src/pages/engagement-summary/utils.ts